import { useMemo, useCallback } from 'react';
import { useApi } from '@micromag/data';

import useData from './useData';

const useStory = (id, opts) => {
    const api = useApi();
    const loader = useCallback(() => api.stories.find(id), [api, id]);
    const { withoutCache = false, ...otherOpts } = opts || {};
    const dataOpts = useMemo(
        () => ({
            ...otherOpts,
            cache: !withoutCache ? ['stories', id] : null,
        }),
        [id, otherOpts, withoutCache],
    );
    const { data, ...request } = useData(loader, dataOpts);
    return {
        story: data,
        ...request,
    };
};

export default useStory;
